import action from "i18n/lang/sv/action";
import common from "i18n/lang/sv/common";
import error from "i18n/lang/sv/error";
import invoice from "i18n/lang/sv/invoice";
import languages from "i18n/lang/sv/languages";
import login from "./login";
import selfcare from "./selfcare";

export const sv = {
  action,
  common,
  invoice,
  languages,
  error,
  login,
  selfcare,
} as const;
